import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { motion, AnimatePresence } from 'framer-motion';

const UnifiedCTA = ({ activeTab }) => {
  const navigate = useNavigate();
  
  const content = {
    0: {
      title: "¿Listo para escalar tu empresa?",
      desc: "Centraliza tu captación de leads, embudos de ventas y contratación de personal de alto nivel. Transforma la forma en la que operas y crece sin límites.",
      cta: "Crear Cuenta de Empresa"
    },
    1: {
      title: "¿Listo para dar el gran salto profesional?",
      desc: "Domina habilidades demandadas, conecta con una comunidad élite y sé contratado por las mejores empresas de nuestro ecosistema.",
      cta: "Empezar como Profesional"
    }
  };
  
  const current = content[activeTab] || content[0];

  return (
    <Box sx={{ background: '#0B0914', py: 12, position: 'relative', overflow: 'hidden' }}>
      {/* Background elements */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          height: '100%',
          background: activeTab === 0 
            ? 'linear-gradient(90deg, rgba(108,77,226,0.1), rgba(242,28,99,0.1))'
            : 'linear-gradient(90deg, rgba(242,28,99,0.1), rgba(41,182,246,0.1))',
          filter: 'blur(100px)',
          zIndex: 0,
          borderRadius: '50%',
          transition: 'background 0.5s ease'
        }}
      />
      
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.4 }}
          >
            <Box
              sx={{
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '24px',
                p: { xs: 4, md: 8 },
                boxShadow: '0 20px 40px rgba(0,0,0,0.5)',
              }}
            >
              <Typography variant="h3" fontWeight={800} color="#fff" mb={3}>
                {current.title}
              </Typography>
              <Typography variant="body1" color="rgba(255,255,255,0.7)" mb={5} sx={{ maxWidth: 600, mx: 'auto', fontSize: '1.1rem' }}>
                {current.desc}
              </Typography>
              
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate('/register')}
                sx={{
                  background: activeTab === 0 
                    ? 'linear-gradient(45deg, #6C4DE2, #F21C63)'
                    : 'linear-gradient(45deg, #F21C63, #29B6F6)',
                  color: '#fff',
                  px: 5,
                  py: 2,
                  borderRadius: '50px',
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  textTransform: 'none',
                  boxShadow: activeTab === 0 
                    ? '0 10px 30px rgba(242,28,99,0.3)'
                    : '0 10px 30px rgba(41,182,246,0.3)',
                  '&:hover': {
                    filter: 'brightness(1.2)'
                  },
                }}
              >
                {current.cta} <ArrowForwardIcon sx={{ ml: 1 }} />
              </Button>
            </Box>
          </motion.div>
        </AnimatePresence>
      </Container>
    </Box>
  );
};

export default UnifiedCTA;
